<template>
  <div>
    <div class="user-intro">
      <div class="user-intro-info">
        <h4 class="user-name">
          {{productDisplayName(selectedProduct)}}
        </h4>

        <div class="row padded" v-if="type != 'copydesk'">
          <div class="col-6 b-r">
            <div class="el-tablo centered highlight">
              <div class="label">Shot</div>
              <div class="value">{{selectedProduct.image_count}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="el-tablo centered highlight">
              <div class="label">Allocated</div>
              <div class="value">{{allocatedCount}}</div>
            </div>
          </div>
        </div>
        <div class="user-social" v-if="type != 'copydesk'">
          <a href="#">
            <i class="fas fa-check-circle" v-if="isQCApproved(selectedProduct) == 1" :class="'qc-'+isQCApproved(selectedProduct)"></i>
            <i class="fas fa-times-circle" v-if="isQCRejected(selectedProduct) == 1" :class="'qc-'+isQCRejected(selectedProduct)"></i>
          </a>
          <a href="#">
            <i class="fas fa-flag flagged" v-if="selectedProduct > 0"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="chat-info-section" v-if="type == 'copydesk'">
      <ProductImageCarousel :product="selectedProduct" :type="'final_images'" v-if="type == 'copydesk'" />
    </div>
    <div class="chat-info-section" v-if="type != 'copydesk'">
      <div class="ci-header">
        <i class="os-icon os-icon-user"></i>
        <span>Contributors</span>
      </div>
      <div class="property-side-features">
        <table class="table table-lightborder ml-3">
                <tbody>
                  <tr
                    v-for="session in ['product', 'model', 'flat']"
                    v-if="type != 'copydesk' && selectedProduct[`${session}_photographer`]"
                  >
                    <td>
                      <div class="value product-name-small text-bold text-capitalize">  {{session}} Session</div>
                      <span class="sub-value">
                        {{selectedProduct[`${session}_photographer`]}}
                        <br />
                        {{selectedProduct[`${session}_location`]}}
                        <br />
                        {{selectedProduct[`${session}_date`]}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="value">
                        <i class="fas" :class="a" />
                      </div>
                      <span class="sub-value"></span>
                    </td>
                  </tr>
                </tbody>
              </table>

        <div class="feature" v-if="type != 'retouchdesk' && type != 'pretouchdesk'">
          <a class="btn btn-danger btn-rounded text-white full-width" v-if="selectedProduct.product_deleted_at == null" @click="dropProduct">Drop Product</a>
          <a class="btn btn-primary btn-rounded text-white full-width" v-if="selectedProduct.product_deleted_at != null" @click="dropProduct">Restore Product</a>
        </div>
        <div class="feature" v-if="selectedProduct.required_session !== null && pendingRefresh == 0 && session !== 'copy'" v-for="session in stringToArray(selectedProduct.required_session)">
          <i class="fas " :class="isSessionComplete(session).icon"></i>
          <span>
            {{capitalize(session)}} Session
            <br />
            <a class="btn btn-sm btn-warning" @click="skipProductSession(session)" v-if="isSessionComplete(session).is_skippable !== 0"> Skip Session</a>
            <a class="btn btn-sm btn-primary" @click="requireProductSession(session)" v-if="isSessionComplete(session).status == 'skipped'"> Require Session</a>
            <span v-if="isSessionComplete(session).status == 'complete'">{{capitalize(isSessionComplete(session).status)}}</span>
          </span>
        </div>
        <MiniLoader v-if="pendingRefresh == 1" :type="'modal'"/>
      </div>
    </div>
    <div class="chat-info-section" v-if="type != 'copydesk'">
      <div class="ci-header">
        <i class="os-icon os-icon-documents-03"></i>
        <span>Workflow</span>
      </div>
      <div class="property-side-features">
        <div class="feature" v-if="type != 'retouchdesk' && type != 'pretouchdesk'">
          <a class="btn btn-danger btn-rounded text-white full-width" v-if="selectedProduct.product_deleted_at == null" @click="dropProduct">Drop Product</a>
          <a class="btn btn-primary btn-rounded text-white full-width" v-if="selectedProduct.product_deleted_at != null" @click="dropProduct">Restore Product</a>
        </div>
        <div class="feature" v-if="selectedProduct.required_session !== null && pendingRefresh == 0 && session !== 'copy'" v-for="session in stringToArray(selectedProduct.required_session)">
          <i class="fas " :class="isSessionComplete(session).icon"></i>
          <span>
            {{capitalize(session)}} Session
            <br />
            <a class="btn btn-sm btn-warning" @click="skipProductSession(session)" v-if="isSessionComplete(session).is_skippable !== 0"> Skip Session</a>
            <a class="btn btn-sm btn-primary" @click="requireProductSession(session)" v-if="isSessionComplete(session).status == 'skipped'"> Require Session</a>
            <span v-if="isSessionComplete(session).status == 'complete'">{{capitalize(isSessionComplete(session).status)}}</span>
          </span>
        </div>
        <MiniLoader v-if="pendingRefresh == 1" :type="'modal'"/>
      </div>
    </div>
    <div class="chat-info-section">
      <div class="ci-header">
        <i class="os-icon os-icon-documents-07"></i>
        <span>Product Info</span>
      </div>
      <div class="ci-content">
        <div class="user-name" v-for="info in quickInfo(selectedProduct)">
          <h6 class="user-title">{{info.value}}</h6>
          <div class="user-role">{{info.name}}</div>
        </div>
      </div>
    </div>

    <div class="chat-info-section">
      <div class="ci-header">
        <i class="os-icon os-icon-user-01"></i>
        <span>Model Info</span>
      </div>
      <div class="ci-content">
        <div class="user-name" v-for="info in modelInfo(selectedProduct)">
          <h6 class="user-title">{{info.value}}</h6>
          <div class="user-role">{{info.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniLoader from '@/components/common/MiniLoader'
import Product from '@/mixins/product'
import ProductImageCarousel from '@/components/common/SessionView/ProductImageCarousel'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  props: ['selectedProduct', 'finalImages', 'session', 'type', 'pendingRefresh'],
  components: { ProductImageCarousel, MiniLoader },
  mixins: [Product, CommonFunctions],
  methods: {
    isQCApproved: function () {
      return this.selectedProduct.qc_done == 1 &&
        this.selectedProduct.qc_state == 1
        ? 1
        : 0
    },
    isQCRejected: function () {
      return this.selectedProduct.qc_done == 1 &&
        this.selectedProduct.qc_state == 0
        ? 1
        : 0
    },
    dropProduct: function () {
      var self = this

      const url = '/productdesk/product/delete'
      let data = {
        id_photodesk_session: self.session.id_photodesk_session,
        id_product: self.selectedProduct.id_product
      }

      self.loading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          location.reload()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    isSessionComplete (session) {
      var self = this
      let complete_session = self.selectedProduct.complete_session
      let skip_session = self.selectedProduct.skip_session

      if (complete_session && complete_session.indexOf(session) > -1) {
        return {
          status: 'complete',
          icon: 'fa-check',
          is_skippable: 0,
          enabled: 1
        }
      }
      if (skip_session && skip_session.indexOf(session) > -1) {
        // skipped
        return {
          status: 'skipped',
          icon: 'fa-ban',
          is_skippable: 0,
          enabled: 1
        }
      }
      return {
        status: 'incomplete',
        icon: 'fa-minus',
        is_skippable: 1,
        enabled: 1
      }
    }
  },
  computed: {
    allocatedCount: function () {
      var self = this
      if (self.finalImages) {
        var list = self.finalImages.filter(function (el) {
          return el.id_image !== null
        })
        return list.length
      }
      return 0
    }
  }
}
</script>

<style>
.btn-xs {
  padding: 0.1rem 0.5rem;
  font-size: 0.3rem;
}
.full-width {
  width: 100%;
}
.side-section .side-section-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}

.property-side-features .feature {
  padding: 10px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
}

.property-side-features .feature i,
.property-side-features .feature span,
.property-side-features .feature strong {
  display: inline-block;
  vertical-align: middle;
}

.property-side-features .feature span {
  color: rgba(0, 0, 0, 0.6);
}

.property-side-features .feature strong {
  margin-right: 3px;
  color: #111;
}

.property-side-features .feature i {
  color: #047bf8;
  font-size: 15px;
  margin-right: 20px;
}

.property-side-features .feature:last-child {
  border-bottom: none;
}
.user-name {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.user-title {
  margin-bottom: 4px;
}
.user-role {
  font-size: 0.63rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
}
.padded{
  padding: 0.5rem 2rem
}
.dispatch-location {
  text-align: left;
  display: inline-block;
}
</style>
